import React, { Fragment, useState } from 'react';
import NavigationItem from './NavigationItem';
import { useSelector } from 'react-redux';
import { translate } from '../Services/translation';

const Navigation = () => {
  const isStartPage = window.location.pathname === '/';
  const [isVisible, setIsVisible] = useState(isStartPage);
  const contentLinks = useSelector((state) => state.navigation.contentLinks);
  const useDrawer = useSelector((state) => state.navigation.useDrawer);

  const toggleVisibility = () => {
    setIsVisible(!isVisible);
  };
  return (
    <div className="row">
      {useDrawer ? (
        <Fragment>
          <div className={`navbar__drawer ${isVisible ? 'open' : 'closed'}`}>
            <NavigationItem links={contentLinks} level={1} />
          </div>
          <div className="navbar__button-container navbar__hide-on-mobile">
            <button
              onClick={toggleVisibility}
              className="navbar__button-expand"
            >
              <i
                className={`smdicon-arrow-up ${isVisible ? 'rotate' : ''}`}
              ></i>
              <div
                className={`navbar__divider ${isVisible ? '' : 'closed'}`}
              ></div>
              <span>
                {isVisible
                  ? translate('code.navbar.button.show')
                  : translate('code.navbar.button.hide')}
              </span>
            </button>
          </div>
        </Fragment>
      ) : (
        <NavigationItem links={contentLinks} level={1} />
      )}
    </div>
  );
};

export default Navigation;
